import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ResourceBundleService } from '../../modules/core/services/resource-bundle.service';
import { GuestService } from '../../modules/core/services/guest.service';
import { Observable } from 'rxjs';
import { select, Store } from '@ngrx/store';
import * as fromRoot from '../../reducers';

@Component({
  selector: 'app-olci-checkin-container',
  templateUrl: './checkin.container.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CheckInContainerComponent {
  screensize$: Observable<any>;
  constructor(
    public resourceBundle: ResourceBundleService,
    public guestService: GuestService,
    private store: Store<fromRoot.AppState>
  ) {
    this.screensize$ = this.store.pipe(select(fromRoot.getContentScreenSize));
  }
}
